import { createBaseStore } from '@/stores/api/base.js';
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useSpaceStore = defineStore('space', () => {
  const currentSpace = ref(null);

  const {
    items: spaces,
    fetchItems: fetch,
    storeItem: store,
    updateItem: update,
    destroy,
  } = createBaseStore('api/workspaces/space');

  const fetchForWorkspace = async (workspace) => {
    const overrideUrl = `/api/workspaces/space?workspace=${workspace}`;
    return await fetch(null, overrideUrl);
  };

  return {
    spaces,
    currentSpace,
    fetch,
    destroy,
    update,
    store,
    fetchForWorkspace,
  };
});
